import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import MainLayout from '../components/Layout';
import App from '../App';
import Products from '../components/Products';
import Contact from '../components/ContactPage';
import Page from '../components/Page';
import Features from '../components/Features';
import PageContent from '../components/PageContent';
import ClientsPage from '../components/ClientsPage';
import LoginRegister from '../components/LoginRegister';
import Page404 from '../components/Error404';

import data from '../data/data.json';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <Layout>
        <Component {...props} />
      </Layout>
    )}
  />
);

class AppRouter extends React.Component {
  state = {
    products: data.products,
    services: data.services,
    prices: data.prices,
    features: data.features,
    clients: data.clients,
    navigation: data.navigation,
    footer: data.footer,
  };

  render() {
    return (
      <Router>
        <Switch>
          <AppRoute path="/" layout={MainLayout} component={App} exact />
          <AppRoute path="/products/:slug" layout={MainLayout} component={PageContent} />
          <AppRoute path="/services/:slug" layout={MainLayout} component={PageContent} />
          <AppRoute path="/login-register" layout={MainLayout} component={LoginRegister} />
          <AppRoute path="/contact" layout={MainLayout} component={Contact} />
          <Route
            path="/pricing"
            render={props => (
              <Page {...props} data={this.state.prices} navigation={this.state.navigation} footer={this.state.footer} />
            )}
          />
          <Route
            path="/features"
            render={props => (
              <Features
                {...props}
                data={this.state.features}
                navigation={this.state.navigation}
                footer={this.state.footer}
              />
            )}
          />
          <Route
            path="/clients"
            render={props => (
              <ClientsPage
                {...props}
                data={this.state.clients}
                navigation={this.state.navigation}
                footer={this.state.footer}
              />
            )}
          />
          <Route
            path="/products"
            render={props => (
              <Products
                {...props}
                data={this.state.products}
                navigation={this.state.navigation}
                footer={this.state.footer}
              />
            )}
          />
          <Route
            path="/services"
            render={props => (
              <Products
                {...props}
                data={this.state.services}
                navigation={this.state.navigation}
                footer={this.state.footer}
              />
            )}
          />
          <AppRoute layout={MainLayout} component={Page404} />
        </Switch>
      </Router>
    );
  }
}
export default AppRouter;



// WEBPACK FOOTER //
// ./src/routes/index.js